"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useNavigationState = void 0;
var React = __importStar(require("react"));
var date_fns_1 = require("date-fns");
var contexts_1 = require("..");
var getInitialMonth_1 = require("./utils/getInitialMonth");
/** Controls the navigation state. */
function useNavigationState() {
    var context = contexts_1.useDayPicker();
    var initialMonth = getInitialMonth_1.getInitialMonth(context);
    var _a = React.useState(initialMonth), month = _a[0], setMonth = _a[1];
    var goToMonth = function (date) {
        if (context.disableNavigation)
            return;
        setMonth(date);
    };
    // Update month if updated from context.
    React.useEffect(function () {
        // TODO: return void also if `context.defaultMonth`?
        if (!context.month)
            return;
        if (date_fns_1.isSameMonth(context.month, month))
            return;
        setMonth(context.month);
    }, [context.month]);
    return [month, goToMonth];
}
exports.useNavigationState = useNavigationState;
//# sourceMappingURL=useNavigationState.js.map